import styled from 'styled-components';
import BackgroundLogo from "../../assets/images/back_logo.png";

const MyDiv = styled.div`
  .login-container {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-flex-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }

  .login-left {
    width: 50%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 7vh 0 0 6vw;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .login-left::before {
    content: "";
    background-image: url(${BackgroundLogo});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }

  .login-logo {
    width: clamp(120px, 10vw, 180px);
    margin-bottom: 3vh;
    background-color: #ffffff;
    mix-blend-mode: multiply;
  }

  .login-left-content {
    max-width: clamp(300px, 35vw, 480px);
  }

  .login-heading {
    white-space: pre-line;
    margin-bottom: 1rem;
    line-height: 1.3;
    font-size: clamp(1.8rem, 2.8vw, 3.2rem);
  }

  .login-subheading {
    white-space: pre-line;
    line-height: 1.6;
    font-size: clamp(0.9rem, 1.2vw, 1.2rem);
  }

  .login-illustration {
    position: absolute;
    bottom: 5vh;
    left: 4vw;
    width: clamp(200px, 22vw, 350px);
    opacity: 0.9;
  }

  .login-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }

  .login-card {
    background-color: #ffffff;
    padding: clamp(1.5rem, 2.5vw, 2.5rem);
    border-radius: 12px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  .login-title {
    margin-bottom: 1.5rem;
    font-size: clamp(1rem, 1.1vw, 1.25rem);
  }

  .form-group {
    margin-top: 1.2rem;
  }

  .input {
    padding: 10px;
    border-radius: 6px;
  }

  .forgot-link {
    text-decoration: underline;
  }

  .login-button {
    width: 100%;
  }

  /* ✅ Responsive behavior for small screens */
  @media (max-width: 992px) {
    .login-flex-wrapper {
      flex-direction: column;
    }

    .login-left {
      width: 100%;
      align-items: center;
      padding: 4vh 2vw;
    }

    .login-right {
      width: 100%;
      padding: 3vh 5vw;
    }

    .login-illustration {
      position: relative;
      bottom: 0;
      left: 0;
      width: 60%;
      margin-top: 3vh;
    }
  }
`;

export default MyDiv;
